import { TApplicationState } from '../../types/redux';

export function getSpecifications(state: TApplicationState) {
  return state.newbuilding.specifications;
}

export function getDetailedSpecifications(state: TApplicationState) {
  return state.newbuilding.specificationsDetailed;
}
